import {FieldConfig} from '../../dynamic-field/field.config';

export interface ButtonToggleFieldConfig extends FieldConfig<any> {
    buttons: {
        [key: string]: ButtonConfig;
    };
    showOutline?: boolean;
    multiSelect?: boolean;
}

export interface ButtonConfig {
    text: string;
    readonly?: boolean;
    class?: string;
}
